import { highmarkCommon } from 'highmark-common.config';

// Temp solution to clear bad session cookies before login using redirects: https://everlong.atlassian.net/browse/HIGHMARK-2846
export const clearHighmarkSessionRedirect = (redirectPath: string = '') =>
  window.location.assign(
    `${highmarkCommon.getConfig().highmarkSsoAppUrl}/logout?end_url=${
      window.location.origin
    }${redirectPath}`,
  );
